import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Import environment
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private http: HttpClient) { }

  forgotPasswordApi = (payload: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/forgotPassword', payload)
  }

}
